import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DateInput, TextInput, useListContext } from "react-admin";
import ReceiptFilterLiveForm, {
  receiptFilterCompactInputProps,
  receiptFilterDateFieldSx,
} from "@/components/receipt-filters/ReceiptFilterLiveForm";
import { RENT_BOOKING_RECEIPT_FILTER_FIELDS } from "./rent-booking-receipt-filter-fields";
import {
  ALL_RECEIPT_CATEGORY,
  RECEIPT_CATEGORY_OPTIONS,
  receiptCategoryId,
} from "./rent-booking-receipt-utils";

const [categoryField, searchField, startField, endField] = RENT_BOOKING_RECEIPT_FILTER_FIELDS;

const ReceiptCategoryFilter = () => {
  const { filterValues, setFilters, displayedFilters } = useListContext();
  const categoryId = receiptCategoryId(
    filterValues?.type ? String(filterValues.type) : undefined,
    filterValues?.mode ? String(filterValues.mode) : undefined
  );

  return (
    <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 220 } }}>
      <InputLabel id="receipt-category-label">{categoryField.label}</InputLabel>
      <Select
        labelId="receipt-category-label"
        label={categoryField.label}
        value={categoryId}
        onChange={(event) => {
          const selected = RECEIPT_CATEGORY_OPTIONS.find(
            (option) => option.id === event.target.value
          );
          if (!selected) return;

          const next = { ...filterValues };
          if (selected.id === ALL_RECEIPT_CATEGORY.id) {
            delete next.type;
            delete next.mode;
          } else if (selected.type && !selected.mode) {
            next.type = selected.type;
            delete next.mode;
          } else {
            next.type = selected.type;
            next.mode = selected.mode;
          }
          setFilters(next, displayedFilters);
        }}
      >
        {RECEIPT_CATEGORY_OPTIONS.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default function RentBookingReceiptFilterBar() {
  return (
    <ReceiptFilterLiveForm>
      <ReceiptCategoryFilter />
      <TextInput
        source={searchField.source}
        label={searchField.label}
        resettable
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 200 }, flex: { sm: "1 1 200px" }, maxWidth: { sm: 360 } }}
      />
      <DateInput
        source={startField.source}
        label={startField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
      <DateInput
        source={endField.source}
        label={endField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
    </ReceiptFilterLiveForm>
  );
}
